import JoditEditor from './JoditEditor';
import { Jodit } from './include.jodit';

export default JoditEditor;
export { Jodit };